import LongTimer from "./LongTimer";

export default LongTimer;